<div class="otp-timer">
  <span class="timer">{{ countdownTimeDisplayText }}</span> <span class="unit">min</span>
</div>